import { v4 as uuidv4 } from 'uuid';
import cogoToast from 'cogo-toast';
import { getUnitPrice, getLineSetupFee, MIN_QTY } from "../../helpers/product";

const { createSlice } = require('@reduxjs/toolkit');

// Re-resolve a cart line's unit price (article tier + chosen print job) and its
// one-off setup fee, from the line's current quantity + printSelection. Quantity
// is always floored at MIN_QTY (30).
const recalcLine = (item) => {
  item.quantity = Math.max(Number(item.quantity) || MIN_QTY, MIN_QTY);
  item.price = getUnitPrice(item, item.quantity, item.printSelection);
  item.setupFee = getLineSetupFee(item, item.printSelection);
  return item;
};

const cartSlice = createSlice({
    name: "cart",
    initialState: {
        cartItems: []
    },
    reducers: {
        addToCart(state, action) {
            const product = {...action.payload};
                  const qty = Math.max(Number(product.quantity) || MIN_QTY, MIN_QTY);
                  product.quantity = qty;
                  product.price = getUnitPrice(product, qty, product.printSelection);
                  product.setupFee = getLineSetupFee(product, product.printSelection);

            if(!product.variation){
                const cartItem = state.cartItems.find(item => item.id === product.id);
                if(!cartItem){

                    state.cartItems.push({
                        ...product,
                        quantity: product.quantity ? product.quantity : 1,
                        cartItemId: uuidv4(),

                    });
                } else {
                    state.cartItems = state.cartItems.map(item => {
                        if(item.cartItemId === cartItem.cartItemId){
                            return recalcLine({
                                ...item,
                                quantity: product.quantity ? item.quantity + product.quantity : item.quantity + 1
                            })
                        }
                        return item;
                    })
                }

            } else {
                const cartItem = state.cartItems.find(
                    item =>
                        item.id === product.id &&
                        product.selectedProductColor &&
                        product.selectedProductColor === item.selectedProductColor &&
                        product.selectedProductSize &&
                        product.selectedProductSize === item.selectedProductSize &&
                        (product.cartItemId ? product.cartItemId === item.cartItemId : true)
                );
            var varia = product.variation.find(
    variant => 
        variant.color === product.selectedProductColor &&
        variant.size.some(sizeObj => 
            sizeObj.name === product.selectedProductSize
        )
);

                if(!cartItem){
                    state.cartItems.push({
                        ...product,
                        quantity: product.quantity ? product.quantity : 1,
                        cartItemId: uuidv4(),
                        variant_id: varia.id
                    });
                } else if (cartItem !== undefined && (cartItem.selectedProductColor !== product.selectedProductColor || cartItem.selectedProductSize !== product.selectedProductSize)) {
                    state.cartItems = [
                        ...state.cartItems,
                        {
                            ...product,
                            quantity: product.quantity ? product.quantity : 1,
                            cartItemId: uuidv4(),
                        variant_id: varia.id

                        }
                    ]
                } else {
                    state.cartItems = state.cartItems.map(item => {
                        if(item.cartItemId === cartItem.cartItemId){
                            return recalcLine({
                                ...item,
                                quantity: product.quantity ? item.quantity + product.quantity : item.quantity + 1,
                                selectedProductColor: product.selectedProductColor,
                                selectedProductSize: product.selectedProductSize
                            })
                        }
                        return item;
                    });
                }
            }

            cogoToast.success("Added To Cart", {position: "bottom-left"});
        },
        deleteFromCart(state, action) {
            state.cartItems = state.cartItems.filter(item => item.cartItemId !== action.payload);
            cogoToast.error("Removed From Cart", {position: "bottom-left"});
        },
        decreaseQuantity(state, action){
            const product = action.payload;
            if (product.quantity <= MIN_QTY) {
                // already at the 30-unit floor — decrement does nothing, use the × button to remove
                return;
            }
            state.cartItems = state.cartItems.map(item =>
                item.cartItemId === product.cartItemId
                    ? recalcLine({ ...item, quantity: item.quantity - 1 })
                    : item
            );
            cogoToast.warn("Item Decremented From Cart", {position: "bottom-left"});
        },
        deleteAllFromCart(state){
            state.cartItems = []
        },
        updateCart(state, action) {
    const updatedItem = action.payload;
    state.cartItems = state.cartItems.map(item =>
        item.cartItemId === updatedItem.cartItemId
            ? recalcLine({ ...item, ...updatedItem })
            : item
    );
    cogoToast.success("Cart Updated", {position: "bottom-left"});
}
    },

});
export const { addToCart, deleteFromCart, decreaseQuantity, deleteAllFromCart, updateCart } = cartSlice.actions;
export default cartSlice.reducer;
